import { render } from "./ImageAndFiles.vue?vue&type=template&id=16116902&scoped=true"
import script from "./ImageAndFiles.vue?vue&type=script&lang=js"
export * from "./ImageAndFiles.vue?vue&type=script&lang=js"

import "./ImageAndFiles.vue?vue&type=style&index=0&id=16116902&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16116902"]])

export default __exports__